import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Grid from "../shared/grid"
import Link from "../shared/link"
import {
  Container,
  OverviewContent,
  LogoRow,
  Logo,
  Title,
  TextContent,
  WebSdkImage,
  MobileSdkImage,
  MobileSdkImageContainer,
  Spacer,
  LinkContainer,
  SdkLinkContainer,
  ButtonStyle,
  DarkButtonStyle,
} from "./overview.style"
import externalLinks from "../../external-links"

export default function OverviewSection() {
  const query = useStaticQuery(graphql`
    query {
      reactIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Coding Language Logos/react_logo.svg"
        }
      ) {
        publicURL
      }
      javaIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Coding Language Logos/java_logo.svg"
        }
      ) {
        publicURL
      }
      swiftIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Coding Language Logos/swift_logo.svg"
        }
      ) {
        publicURL
      }
      webSdkImage: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/web_sdk_device.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mobileSdkImgLg: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/mobile_sdks_dektop.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mobileSdkImg: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/mobile_sdks_tablet_mobile.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Container>
      <Grid>
        <WebSdkImage
          fluid={query.webSdkImage.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
        <OverviewContent>
          <LogoRow>
            <Logo src={query.reactIcon.publicURL} />
          </LogoRow>
          <Title>Web SDK</Title>
          <TextContent>
            Mappedin’s Web SDK has been leveraged to build experiences across
            all devices and platforms. This SDK is what Mappedin’s pre-built
            applications are built on, meaning its capabilities are constantly
            expanding.
          </TextContent>
          <LinkContainer>
            <Link
              styleModifier={DarkButtonStyle}
              href={externalLinks.webDocs}
              internal
            >
              Documentation
            </Link>
            <Link
              styleModifier={ButtonStyle}
              href={externalLinks.webSamples}
              internal
            >
              Sample Apps
            </Link>
          </LinkContainer>
        </OverviewContent>
        <Spacer />
        <MobileSdkImageContainer>
          <MobileSdkImage
            fluid={query.mobileSdkImg.childImageSharp.fluid}
            imgStyle={{ objectFit: "contain" }}
          />
        </MobileSdkImageContainer>
        <OverviewContent>
          <LogoRow>
            <Logo src={query.swiftIcon.publicURL} />
            <Logo src={query.javaIcon.publicURL} />
          </LogoRow>
          <Title>
            <b>i</b>OS & Android SDKs
          </Title>
          <TextContent>
            Mappedin’s Mobile SDKs are highly performant; work offline, and
            include key navigational features. With the ability to integrate
            indoor positioning technology, building your real-time mapping
            experience has never been simpler.
          </TextContent>
          <SdkLinkContainer>
            <Link
              styleModifier={DarkButtonStyle}
              href={externalLinks.developerPortal}
              internal
            >
              Documentation
            </Link>
          </SdkLinkContainer>
        </OverviewContent>
      </Grid>
    </Container>
  )
}
